import declare from "dojo/_base/declare";
import config from "csi/config";
import Widget from "csi/form/Widget";

const SUBTYPE = "Subtype";

const ProductHierarchyFolderForm = declare(Widget, {

	/**
	 * @override
	 * Insert Subtype field if it hasn't been added to the FormDefinition
	 */
	_resolveView() {
		this.insertFieldIfNotExist(SUBTYPE, 0);
		const subtypes = this.getProductHierarchyFolderSubtypes();
		const level = this.getCache().get(this.getFormNode()?.__Parent__)?.Level;
		this.addDefaultValue(SUBTYPE, subtypes[level]);
		this.setFieldDisabled(SUBTYPE, true);
		this.inherited(arguments);
	},

	getProductHierarchyFolderSubtypes() {
		let curr = this.getFormNode();
		const cache = this.getCache();

		while (curr && curr.$Type != "ProductHierarchy") {
			curr = cache.get(curr.__Parent__);
		}

		return curr ? config.getSubtypeSetting(curr.Subtype, "ProductHierarchyFolders") : [];
	},
});

export = ProductHierarchyFolderForm;